const DEFAULT_REFRESH_MARGIN_MS = 30 * 1000

export const decodeJwtExpMs = (token) => {
  if (!token || typeof token !== 'string') return 0
  try {
    const payload = token.split('.')[1]
    if (!payload) return 0
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const json = JSON.parse(decodeURIComponent(escape(atob(normalized))))
    return typeof json.exp === 'number' ? json.exp * 1000 : 0
  } catch (e) {
    return 0
  }
}

export const shouldRefreshAccessToken = (token, marginMs = DEFAULT_REFRESH_MARGIN_MS) => {
  if (!token) return true
  const expMs = decodeJwtExpMs(token)
  return expMs > 0 && expMs - Date.now() <= marginMs
}
